import { render, staticRenderFns } from "./StatisticsTable.vue?vue&type=template&id=7b45401c&scoped=true&"
import script from "./StatisticsTable.vue?vue&type=script&lang=js&"
export * from "./StatisticsTable.vue?vue&type=script&lang=js&"
import style0 from "./StatisticsTable.vue?vue&type=style&index=0&id=7b45401c&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b45401c",
  null
  
)

export default component.exports